/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Rate classification of a product by duration — and the unit of its price.
 *
 * Shared by tenancy contract rates and product billing: products shorter
 * than 30 minutes are CHILD_SHORT, 30-60 minutes CHILD_LONG, longer GENERAL.
 *
 * The variant carries a second meaning: it decides what a rate's ``value``
 * buys. Child variants price a whole copy (a flat amount, paid out in full
 * for a fully consumed product); GENERAL prices one listening hour.
 */
export type RateVariant = typeof RateVariant[keyof typeof RateVariant];


export const RateVariant = {
  general: 'general',
  child_short: 'child_short',
  child_long: 'child_long',
} as const;
